module.exports = __webpack_public_path__ + "img/quickblue.046ba06b.png";